import React from 'react';
import { Button, HStack, useColorModeValue } from '@chakra-ui/react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // Calculate the pages to display
  const pagesToShow = [];
  const maxPagesToShow = 3;
  
  // Add first pages
  for (let i = 1; i <= Math.min(maxPagesToShow, totalPages); i++) {
    pagesToShow.push(i);
  }

  // Add center pages
  if (totalPages > maxPagesToShow * 2 + 1) {
    if (currentPage > maxPagesToShow + 1) {
      pagesToShow.push('...');
    }
    for (let i = Math.max(maxPagesToShow + 1, currentPage - maxPagesToShow); i <= Math.min(totalPages - maxPagesToShow, currentPage + maxPagesToShow); i++) {
      pagesToShow.push(i);
    }
    if (currentPage < totalPages - maxPagesToShow) {
      pagesToShow.push('...');
    }
  } else {
    for (let i = Math.max(maxPagesToShow + 1, totalPages - maxPagesToShow); i <= totalPages; i++) {
      pagesToShow.push(i);
    }
  }

  // Ensure last two pages are always shown
  if (totalPages > maxPagesToShow * 2) {
    const lastTwoPages = [totalPages - 1, totalPages];
    lastTwoPages.forEach(page => {
      if (!pagesToShow.includes(page) && page > maxPagesToShow) {
        pagesToShow.push(page);
      }
    });
    // Sort to ensure correct order
    pagesToShow.sort((a, b) => a - b);
  }

  return (
    <HStack spacing={2} justify="center" mt={4} py={2} borderTop="1px solid" borderColor={useColorModeValue("gray.200", "gray.700")}>
      <Button
        onClick={() => handlePageChange(currentPage - 1)}
        isDisabled={currentPage === 1}
        variant="outline"
      >
        قبلی
      </Button>
      {pagesToShow.map((page, index) => (
        page === '...' ? (
          <Button key={index} variant="outline" isDisabled>
            {page}
          </Button>
        ) : (
          <Button
            key={index}
            onClick={() => handlePageChange(page)}
            variant={currentPage === page ? "solid" : "outline"}
          >
            {page}
          </Button>
        )
      ))}
      <Button
        onClick={() => handlePageChange(currentPage + 1)}
        isDisabled={currentPage === totalPages}
        variant="outline"
      >
        بعدی
      </Button>
    </HStack>
  );
};

export default Pagination;
